var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.83333C2.5 5.96667 2.5 5.03333 2.86333 4.32C3.18291 3.69282 3.69282 3.18291 4.32 2.86333C5.03333 2.5 5.96667 2.5 7.83333 2.5H12.1667C14.0333 2.5 14.9667 2.5 15.68 2.86333C16.3072 3.18291 16.8171 3.69282 17.1367 4.32C17.5 5.03333 17.5 5.96667 17.5 7.83333V12.1667C17.5 14.0333 17.5 14.9667 17.1367 15.68C16.8171 16.3072 16.3072 16.8171 15.68 17.1367C14.9667 17.5 14.0333 17.5 12.1667 17.5H7.83333C5.96667 17.5 5.03333 17.5 4.32 17.1367C3.69282 16.8171 3.18291 16.3072 2.86333 15.68C2.5 14.9667 2.5 14.0333 2.5 12.1667V7.83333Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.035 8.92508C11.595 9.38091 11.875 9.60925 11.875 10.0001C11.875 10.3909 11.595 10.6192 11.035 11.0751C10.8808 11.2017 10.7267 11.3209 10.5867 11.4192C10.4535 11.512 10.3173 11.6004 10.1783 11.6842C9.62 12.0234 9.34 12.1934 9.09 12.0051C8.84 11.8167 8.81667 11.4242 8.77083 10.6367C8.7581 10.4248 8.75115 10.2125 8.75 10.0001C8.75 9.80425 8.75833 9.58591 8.77083 9.36341C8.81667 8.57591 8.83917 8.18258 9.09 7.99508C9.34 7.80675 9.62 7.97675 10.1783 8.31591C10.3233 8.40425 10.4625 8.49425 10.5867 8.58091C10.7275 8.67925 10.8808 8.79841 11.035 8.92425",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/videoIcon.0e7eae632bd3c6ec66a813b3c9fdacd1.svg";
export { ForwardRef as ReactComponent };